import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQAccordion({
  items
}: {
  items: FAQItemProps[];
}) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <div className="mx-auto w-full max-w-3xl space-y-4" data-id="element-163">
      {items.map((item, index) => <div key={index} className="overflow-hidden rounded-2xl border border-dark-border bg-dark-card transition-colors hover:border-gray-700" data-id="element-164">
          <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="flex w-full items-center justify-between p-6 text-left focus:outline-none" data-id="element-165">
            <span className="font-display text-lg font-semibold text-gray-100 pr-8" data-id="element-166">
              {item.question}
            </span>
            <ChevronDown className={`h-6 w-6 flex-shrink-0 text-cyan transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-167" />
          </button>
          <AnimatePresence initial={false} data-id="element-168">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-169">
                <div className="px-6 pb-6 text-gray-400 leading-relaxed" data-id="element-170">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}